module.exports = __webpack_public_path__ + "img/csr_swiper_04_05.d62c9ce5.jpg";